import { makeAutoObservable, runInAction, toJS } from 'mobx'
import { openApi } from '../../../helpers/request'
import i from '../../../translations/i'
import { FormEvent } from 'react'
import { notification } from 'antd'
import { __cpl } from '../custom_product_lists/__cpl'
import __select from "../../../helpers/select_entity/__select.controller";
import { storeLocal } from "../../../helpers/stores";

class ProductController {
    item: any = {
        id: 0,
        name: '',
        price: null,
        old_price: null,
        text: null,
        id_crm: null,
        view: true,
        visible_for_user: true,
        count: null,
        view_variations: false,
        is_variant: false,
        product_id: null,
        vendor_code: null,
        unit_id: null,
        step: 1,
        view_per_unit: 0,
        weight_goods: false,
        cart_limit: null,
        cart_limit_min: null,
        ban_on_discount: false,
        show_pictures: true,
        allow_adding_to_cart: true,
        allow_transition_to_product_card: true,
        custom_button_enabled: false,
        custom_button_text: null,
        custom_button_entity_type: null,
        custom_button_entity_id: null,
        write_points: true,
        buy_button: null,
        free_text: null,
        bonus_ban: false,
        increased_cashback: false,
        adult_content: false,
        hide_stock: false,
        increased_cashback_type: 0,
        increased_cashback_value: 1,
        categories: [],
        barcodes: [],
        images: [],
        storages: [],
        type: [],
        modifiers_groups: [],
        filter_values: [],
        name_encode: null,
        seo_title: null,
        seo_description: null,
        seo_keywords: null,
        rel: [],
        docs: [],
        weight: 0,
        volume: 0,
        tags: [],
        prices: [],
        prices_wh: [],
        is_set: false,
        is_set_contents: true,
        is_set_disassembled: false,
        is_set_view_type: 1,
        sets: [],
        is_set_label: null,
        calories: 0,
        proteins: 0,
        fats: 0,
        carbohydrates: 0,
        nutritional_value_100_gr: false,
        product_relations: [],
        vat_code: null
    }

    item_tab = 'main'
    modalOpened = false
    modalSetsOpened = false
    selectedBlock: any = {
        product_list: true,
        split: false
    }
    selectedBlockIndex: number = 0
    deletedFiles: any = []

    selectedImageIndex = 0
    imageVideoLink = ''
    filesToEdit: any = []

    tree: any[] = []
    categoryTreeLoaded = false
    categoryTreeLoading = false

    modifiers_groups: any[] = []
    modifiersGroupsLoaded = false
    modifiersGroupsLoading = false

    new_tag: string | null = null

    constructor() {
        makeAutoObservable(this)
    }

    changeTab(tab: string) {
        this.item_tab = tab
    }

    deleteOne(id: number) {
        const data = new FormData()
        data.append('elements[]', `${id}`)

        openApi('post', '/shop/product/delete', data)
            .then(result => {
                this.getOne(this.item.id)
            })

    }

    getOne(product_id: number | string) {
        openApi('get', `/products/${product_id}?with[]=images&with[]=barcodes&with[]=storages&with[]=types&with[]=categories&with[]=variations&with[]=rel&with[]=docs&with[]=sets&with[]=seller&with[]=modifiers_groups_all`)
            .then(result => {
                console.log(result)
                this.item = result.data

                this.item.modifiers_groups = Array.isArray(result.data.modifiers_groups_all)
                    ? result.data.modifiers_groups_all.map((group: any) => group.id)
                    : []

                let rel: any = []
                result.data.rel.map((item: any) => {
                    let lists: any = []
                    item.group.lists.map((list: any) => {
                        if(list?.custom_list){
                            lists.push(list.custom_list)
                        }
                    })

                    rel.push({
                        id: item.group.id,
                        name: item.group.label,
                        type: item.group?.lists?.length > 0 ? 'lists' : '',
                        product_list: item.group?.product_list,
                        split: item.group?.split,
                        lists: lists
                    })
                })
                this.item.rel = rel

                let docs: any = []
                result.data.docs.map((group: any) => {
                    let files: any = []
                    group.files.map((file: any) => {
                        files.push({
                            id: file.id,
                            uid: file.id,
                            status: 'done',
                            name: file?.filename ?? file.uri.split('/')[1],
                            url: `${file.base}${file.uri}`,
                            uri: file.uri
                        })
                    })

                    docs.push({
                        id: group.group.id,
                        label: group.group.label,
                        files: files
                    })
                })
                this.item.docs = docs

                __select.setRefer(result.data.refer)

            })
            .catch(error => {
                console.log(error)
                console.log(error.response)
            })
    }

    sendForm(e: FormEvent) {
        e.preventDefault()
        this.save()
    }

    /**
     * При создании товара и при правке своего Франчайзи редактирует все поля как обычно -
     * ограничен только чужой существующий товар (см. fieldsDisabled в Product.tsx и бэкенд
     * updateFranchiseeWarehousePrices()). Эта функция лишь подставляет строки складов
     * Франчайзи, которых ещё нет в this.item.storages, чтобы было что показать на вкладке.
     */
    ensureFranchiseeStorages() {
        const allowedWarehouseIds: number[] = storeLocal.get('warehouses_access') || []
        const existingIds = this.item.storages.map((el: any) => el.warehouseid)

        const missing = allowedWarehouseIds.filter((id: number) => !existingIds.includes(id))

        if (missing.length > 0) {
            runInAction(() => {
                this.item.storages = [
                    ...this.item.storages,
                    ...missing.map((warehouseid: number) => ({
                        warehouseid,
                        view: 1,
                        price: 0,
                        priceold: 0,
                        count: 0
                    }))
                ]
            })
        }
    }

    save() {
        const data = new FormData()

        data.append('name', this.item.name)
        data.append('price', this.item.price)
        // Отправляем всегда: 0 или пустое поле снимает старую цену
        data.append('old_price', `${this.item.old_price ?? ''}`)
        data.append('text', this.item.text)
        data.append('id_crm', this.item.id_crm)
        data.append('view', `${+ this.item.view}`)
        data.append('visible_for_user', `${+ this.item.visible_for_user}`)
        data.append('count', `${this.item.count}`)
        data.append('view_variations', `${+ this.item.view_variations}`)
        data.append('is_variant', `${+ this.item.is_variant}`)
        data.append('product_id', `${this.item.product_id}`)
        data.append('vendor_code', this.item.vendor_code)
        data.append('unit_id', this.item.unit_id)
        data.append('step', this.item.step)
        data.append('view_per_unit', `${+ this.item.view_per_unit}`)
        data.append('weight_goods', `${+ this.item.weight_goods}`)
        data.append('cart_limit', this.item.cart_limit)
        data.append('cart_limit_min', this.item.cart_limit_min ?? '0')
        data.append('ban_on_discount', `${+ this.item.ban_on_discount}`)
        data.append('show_pictures', `${+ this.item.show_pictures}`)
        data.append('allow_adding_to_cart', `${+ this.item.allow_adding_to_cart}`)
        data.append('allow_transition_to_product_card', `${+ this.item.allow_transition_to_product_card}`)
        data.append('weight', `${this.item.weight}`)
        data.append('volume', `${this.item.volume}`)
        data.append('custom_button_enabled', `${+ this.item.custom_button_enabled}`)
        data.append('custom_button_text', this.item.custom_button_text)
        data.append('calories', `${this.item.calories}`)
        data.append('proteins', `${this.item.proteins}`)
        data.append('fats', `${this.item.fats}`)
        data.append('carbohydrates', `${this.item.carbohydrates}`)
        data.append('nutritional_value_100_gr', `${+ this.item.nutritional_value_100_gr}`)
        data.append('write_points', `${+ this.item.write_points}`)
        data.append('vat_code', this.item.vat_code ? `${+ this.item.vat_code}` : '')

        data.append('adult_content', `${+ this.item.adult_content}`)
        data.append('hide_stock', `${+ this.item.hide_stock}`)

        if(this.item.name_encode) data.append('name_encode', this.item.name_encode)
        if(this.item.seo_title) data.append('seo_title', this.item.seo_title)
        if(this.item.seo_description) data.append('seo_description', this.item.seo_description)
        if(this.item.seo_keywords) data.append('seo_keywords', this.item.seo_keywords)

        if(__select.select.type !== '') {
            data.append('refer_type', __select.select.type)

            if(__select.select.type === 'custom_product_list') {
                if(__cpl.selectedLists[0] > 0) {
                    data.append('refer_id', __cpl.selectedLists[0])
                } else {
                    // hasError = true
                }
            } else {
                if(__select.select.value || (__select.select.type === 'category' && __select.select.value === '')) {
                    if(__select.select.type === 'url' || __select.select.type === 'url_blank'){
                        data.append('refer_value', __select.select.value)
                    } else {
                        data.append('refer_id', __select.select.value)
                    }
                }
            }
        }

        data.append('buy_button', this.item.buy_button)
        data.append('free_text', this.item.free_text)
        data.append('bonus_ban', `${+ this.item.bonus_ban}`)
        data.append('increased_cashback', `${+ this.item.increased_cashback}`)
        data.append('increased_cashback_type', this.item.increased_cashback_type)
        data.append('increased_cashback_value', this.item.increased_cashback_value)

        if(this.item.types && Array.isArray(this.item.types) && this.item.types.length > 0)
            this.item.types.map((type_id: number) => data.append('types[]', `${type_id}`))
        else data.append('types', ``)

        if(this.item.categories && Array.isArray(this.item.categories) && this.item.categories.length > 0)
            this.item.categories.map((category_id: number) => data.append('categories[]', `${category_id}`))
        else {
            notification.error({
                message: i.t('def:errors.error'),
                description: i.t('def:errors.emptyCategory'),
            })
            return
        }

        if(this.item.modifiers_groups && Array.isArray(this.item.modifiers_groups) && this.item.modifiers_groups.length > 0) {
            this.item.modifiers_groups.map((group_id: number) => {
                data.append('modifiers_groups[]', `${group_id}`)
            })
        } else {
            data.append('modifiers_groups', ``)
        }

        if(this.item.barcodes && Array.isArray(this.item.barcodes) && this.item.barcodes.length > 0) {
            this.item.barcodes.map((item: any, i: number) => {
                if (item.id) data.append(`barcodes[${i}][id]`, item.id ? `${item.id}` : `0`);
                data.append(`barcodes[${i}][value]`, `${item.value}`);
            });
        } else data.append('barcodes', ``)

        if(this.item.images && Array.isArray(this.item.images) && this.item.images.length > 0) {
            this.item.images.map((item: any, i: number) => {
                data.append(`images[${i}][sorting]`, `${item.sorting}`);
                if (item.id) data.append(`images[${i}][id]`, `${item.id}`);
                else data.append(`images[${i}][id]`, `0`);
                if (item.file) data.append(`file_${i}`, item.file);
                if (item.video_uri) {
                    data.append(`images[${i}][video_uri]`, `${item.video_uri}`);
                }
            });
        } else data.append('images', ``)

        if(this.item.storages && Array.isArray(this.item.storages) && this.item.storages.length > 0) {
            this.item.storages.map((item: any, i: number) => {
                data.append(`warehouses[${i}][warehouseid]`, `${item.warehouseid}`);
                data.append(`warehouses[${i}][view]`, `${+item.view}`);
                data.append(`warehouses[${i}][priceold]`, `${item.priceold}`);
                data.append(`warehouses[${i}][price]`, `${item.price}`);
                data.append(`warehouses[${i}][count]`, `${item.count}`);
            });
        } else data.append('warehouses_clear', `1`)

        if(this.item.filter_values && Array.isArray(this.item.filter_values))
            this.item.filter_values.map((el: number, i: number) => data.append(`props[${i}]`, `${el}`))
        else data.append('props', ``)

        if(this.item.rel && Array.isArray(this.item.rel) && this.item.rel.length > 0) {
            this.item.rel.map((block: any, index: number) => {
                if(block.name !== null && block.name !== ''){
                    if(block.id > 0) {
                        data.append(`related[${index}][id]`, block.id)
                    }
                    data.append(`related[${index}][label]`, block.name)
                    data.append(`related[${index}][product_list]`, `${+ block.product_list}`)
                    data.append(`related[${index}][split]`, `${+ block.split}`)

                    if(block.type === 'lists') {
                        block.lists.map((list: any, k: number) => {
                            data.append(`related[${index}][list][${k}]`, `${list.id}`)
                        })
                    }
                }
            })
        } else data.append('related', ``)


        let index_relations_list = 0

        if(this.item.product_relations && Array.isArray(this.item.product_relations) && this.item.product_relations.length > 0) {
            this.item.product_relations.map((link_element: any, index: number) => {
                console.log(link_element)
                data.append(`product_relations[${index}][product_id]`, link_element.product_id)

                if(link_element.lists && Array.isArray(link_element.lists) && link_element.lists.length > 0) {
                    link_element.lists.map((list: any, k: number) => {
                        data.append(`product_relations_lists[${index_relations_list}][category_id]`, `${list.category_id}`)
                        data.append(`product_relations_lists[${index_relations_list}][product_id]`, `${link_element.product_id}`)
                        index_relations_list++
                    })
                }
            })
        } else data.append('product_relations', ``)

        if(index_relations_list === 0) {
            data.append('product_relations_lists', ``)
        }


        if(this.item.docs && Array.isArray(this.item.docs) && this.item.docs.length > 0) {
            this.item.docs.map((group: any, index: number) => {
                if(group.label === null || group.label === '' || group.files.length === 0) {
                    return notification.error({
                        message: i.t('def:errors.error'),
                        description: i.t('def:errors.data')
                    })
                }
                if(group.id > 0) {
                    data.append(`docs[${index}][id]`, group.id)
                }
                data.append(`docs[${index}][label]`, `${group.label}`)
                data.append(`docs[${index}][key]`, `docs_${index}`)

                group.files.map((file: any, k: number) => {
                    if(file.uri){

                    } else {
                        data.append(`docs_${index}[${k}]`, file)
                    }
                })
            })
        }else data.append('docs', ``)

        if(this.item.prices && Array.isArray(this.item.prices) && this.item.prices.length > 0) {
            this.item.prices.map((price: any, index: number) => {
                console.log(price)
                data.append(`prices[${index}][price_type_id]`, `${price.price_type_id}`)
                data.append(`prices[${index}][price]`, `${price.price}`)
                data.append(`prices[${index}][old_price]`, price.old_price ? `${price.old_price}` : '0')
            })
        }else data.append('prices', ``)

        if(this.item.prices_wh && Array.isArray(this.item.prices_wh) && this.item.prices_wh.length > 0) {
            this.item.prices_wh.map((price: any, index: number) => {
                data.append(`prices_wh[${index}][price_type_id]`, `${price.price_type_id}`)
                data.append(`prices_wh[${index}][price]`, `${price.price}`)
                data.append(`prices_wh[${index}][warehouse_id]`, `${price.warehouse_id}`)
                data.append(`prices_wh[${index}][old_price]`, price.old_price ? `${price.old_price}` : '0')
            })
        }else data.append('prices_wh', ``)


        this.deletedFiles.map((fileID: number) => {
            openApi('delete', `/file/${fileID}`)
                .then((result: any) => {

                })
        })

        if(this.item.tags.length > 0) {
            this.item.tags.map((el: string, index: number) => {
                data.append(`tags[${index}]`, el)
            })
        } else data.append('tags', ``)

        data.append('is_set', `${+ this.item.is_set}`)
        data.append('is_set_contents', `${+ this.item.is_set_contents}`)
        data.append('is_set_disassembled', `${+ this.item.is_set_disassembled}`)
        data.append('is_set_view_type', `${+ this.item.is_set_view_type}`)
        if(this.item.is_set_label) data.append('is_set_label', `${ this.item.is_set_label}`)


        if(this.item.sets.length > 0) {
            this.item.sets.map((el: any, index: number) => {
                data.append(`sets[${index}][product_id]`, el.product_id)
                data.append(`sets[${index}][count]`, el.count)
            })
        } else data.append('sets', ``)

        data.append('seller', this.item.seller && this.item.seller.manager_id ? `${this.item.seller.manager_id}` : '')

        openApi('post', `/products/${this.item.id}`, data)
            .then(result => {
                if(this.item.id > 0) {
                    this.getOne(result.data.id)
                    notification.success({
                        message: i.t('def:success.success'),
                        description: i.t('def:success.edit')
                    })
                } else {
                    window.location.href = `/shop/catalog/product/${result.data.id}`
                }
            })
            .catch(error => {
                console.log(error.response)
                notification.error({
                    message: i.t('def:errors.error'),
                    description: error.response.data.data.message ?? 'error'
                })
            })
    }

    getCategoryTree(force = false) {
        if (!force && (this.categoryTreeLoaded || this.categoryTreeLoading)) return

        this.categoryTreeLoading = true

        openApi('get', `/category/tree`)
            .then(result => {
                this.tree = result.data
                this.categoryTreeLoaded = true
            })
            .catch(error => console.log(error.response))
            .finally(() => {
                this.categoryTreeLoading = false
            })
    }

    addBarcodeToItem() {
        this.item.barcodes.push({

        })
    }

    saveBlockLabel(value: any) {
        this.item.product_relations.map((el: any) => el.block_label = value)
    }

    handleOnDragEnd(result: any) {
        const items = Array.from(this.item.images)
        const [reorderedItem] = items.splice(result.source.index, 1)
        items.splice(result.destination.index, 0, reorderedItem)

        this.item.images = items
    }

    sortingPictures(index: number, action: string) {

        let array: any[] = []

        this.item.images.map((el: any, i: number) => {
            el.sorting = i
            array.push(el)
        })

        if(action === 'top') {
            if(array[index-1]) {
                let this_element = array[index]
                let prev_element = array[index-1]

                array[index-1].sorting = this_element.sorting
                array[index].sorting = prev_element.sorting
            }
        } else {
            if(array[index+1]) {
                let this_element = array[index]
                let prev_element = array[index+1]

                array[index+1].sorting = this_element.sorting
                array[index].sorting = prev_element.sorting
            }
        }

        array.sort((el1, el2) => el1['sorting'] > el2['sorting'] ? 1 : -1)

        let array2: any[] = []

        array.map((el: any, i: number) => {
            el.sorting = i
            array2.push(el)
        })

        this.item.images = array2

        return
    }

    moveImage(fromIndex: number, toIndex: number) {
        if (fromIndex === toIndex) return

        const images = [...this.item.images]
        const [image] = images.splice(fromIndex, 1)

        images.splice(toIndex, 0, image)

        this.item.images = images.map((item: any, index: number) => ({
            ...item,
            sorting: index + 1
        }))
    }

    deleteImage(index: number) {
        this.item.images.splice(index, 1)
    }

    setProductStorageID(warehouse_id: number, value: boolean) {
        const storage = this.item.storages.find((el: any) => el.warehouseid === warehouse_id);

        if (value) {
            if (storage) {
                storage.view = 1;
            } else {
                this.item.storages.push({
                    warehouseid: warehouse_id,
                    view: 1,
                    price: 0,
                    priceold: 0,
                    count: 0
                });
            }
        } else if (storage) {
            storage.view = 0;
        } else {
            this.item.storages = this.item.storages.filter((el: any) => el.warehouseid !== warehouse_id);
        }
    }

    setProductDataToStorage(warehouse_id: number, field_name: string, value: number) {
        let element = this.item.storages.find((el: any) => el.warehouseid === warehouse_id)
        let list = this.item.storages.filter((el: any) => el.warehouseid !== warehouse_id)
        element[field_name] = value
        list.push(element)
        this.item.storages = list
    }

    createVar() {
        openApi('post', `/products/var/${this.item.id}`)
            .then(result => {
                console.log(result.data)
                this.getOne(this.item.id)
            })
            .catch((error) => console.log(error.response))
    }

    addBlock() {
        this.item.rel.push({
            id: 0,
            name: null,
            type: '',
            lists: []
        })
    }

    removeBlock(index: number) {
        this.item.rel.splice(index, 1)
    }

    openModal(index: number) {
        this.selectedBlockIndex = index
        console.log(this.item.rel[index])
        let selectedBlock = toJS(this.item.rel[index])
        let lists: any = []
        selectedBlock.lists.map((list: any) => {
            lists.push(list.id)
        })

        if(!selectedBlock.id) {
            selectedBlock.product_list = true;
            selectedBlock.split = false;
        }

        __cpl.selectedLists = lists
        this.selectedBlock = selectedBlock
        this.modalOpened = true
    }

    closeModal(force: boolean = false) {
        if(!force) {
            if(this.selectedBlock.name === '' || this.selectedBlock.name === null) {
                return notification.error({
                    message: i.t('def:errors.error'),
                    description: i.t('def:errors.data')
                })
            }

            let lists: any = []
            __cpl.selectedLists.map((listID: number) => {
                lists.push(__cpl.list.find(el => el.id === listID))
            })
            this.selectedBlock.lists = lists
            this.item.rel[this.selectedBlockIndex] = toJS(this.selectedBlock)
        }

        this.modalOpened = false

        setTimeout(() => {
            this.selectedBlock = { product_list: true, split: false }
            this.selectedBlockIndex = 0
            __cpl.selectedLists = []
        }, 300)
    }

    addFilesGroup() {
        this.item.docs.push({
            id: 0,
            label: null,
            files: []
        })
    }

    removeFilesGroup(index: number) {
        this.item.docs.splice(index, 1)
    }

    toggleFile(i: number, file: any, multiple: boolean = true) {
        let index = this.item.docs[i].files.findIndex((el: any) => el.uid === file.uid)
        let array = toJS(this.item.docs[i].files)
        if(index > -1) {
            if(file?.id > 0) {
                this.deletedFiles.push(file.id)
            }
            array.splice(index, 1)
        } else {
            if(multiple) {
                array.push(file)
            } else {
                array = [file]
            }
        }
        this.item.docs[i].files = array
    }

    openImagesModal(index: number) {
        this.selectedImageIndex = index
        this.imageVideoLink = toJS(this.item.images[this.selectedImageIndex]?.video_uri ?? '')
        this.modalOpened = true
    }

    closeImagesModal(force: boolean = false) {
        if(!force) {
            if(this.imageVideoLink === '') {
                // return notification.error({
                //     message: i.t('def:errors.error'),
                //     description: i.t('def:errors.data')
                // })
            }

            this.item.images[this.selectedImageIndex].video_uri = toJS(this.imageVideoLink)
        }

        console.log(this.item.images)

        this.modalOpened = false

        setTimeout(() => {
            this.imageVideoLink = ''
            this.selectedImageIndex = 0
        }, 300)
    }

    toggleEditFile(file: any, action: string = 'edit', index: number = -1, editingFileIndex: number = -1) {
        if(action === 'edit') {
            this.filesToEdit.push(toJS(file))
        } else if(action === 'save') {
            if(editingFileIndex > -1 && index > -1) {
                let fileIndex = this.item.docs[index].files.findIndex((el: any) => el.id === file.id)

                if(fileIndex > -1) {
                    let newFile = toJS(this.filesToEdit[editingFileIndex])
                    let fileName = newFile?.name ?? ''

                    if(fileName === '') {
                        return notification.error({
                            message: i.t('def:errors.error'),
                            description: i.t('def:Fill File Name')
                        })
                    }

                    this.item.docs[index].files[fileIndex] = newFile
                    this.filesToEdit.splice(editingFileIndex, 1)

                    const data = new FormData()

                    data.append('filename', fileName)

                    console.log(`/file/${newFile.id}`)

                    openApi('post', `/file/${newFile.id}`, data)
                        .then(result => {
                            notification.success({
                                message: i.t('def:success.success'),
                                description: i.t('def:File Saved')
                            })
                        })
                        .catch(error => {
                            notification.error({
                                message: i.t('def:errors.error'),
                                description: error.response.data.data.message ?? 'error'
                            })
                        })
                }
            }
        }
    }

    addTag() {
        this.item.tags.push(this.new_tag)
        this.new_tag = null
    }

    deleteTag(tag: string) {
        this.item.tags = this.item.tags.filter((el: string) => el !== tag)
    }

    setSets() {
        __select.select.value_array = this.item.sets_products ?? []
    }

    saveSets() {
        this.modalSetsOpened = false
    }

    saveRel() {
        this.modalSetsOpened = false

        let path = `/products/relations?test=false`

        this.item.product_relations.map((el: any, index: number) => {
            path += `&ids[${index}]=${el.product && el.product.id ? el.product.id : el.product_id}`
        })

        if(this.item.id) path += `&ids[]=${this.item.id}`

        openApi('get', path)
            .then(result => {
                console.log(result)
                this.item.product_relations = result.data
            })
            .catch(error => {
                console.log(error.response)
            })
    }

    deleteSet(product_id: number) {
        this.item.sets = this.item.sets.filter((el: any) => el.product_id !== product_id)
    }

    deleteLink(product_id: number) {
        this.item.links_to_products = this.item.links_to_products.filter((el: any) => el.product_id !== product_id)
    }

    setPrice(
        price_type_id: number,
        field: 'price' | 'old_price',
        value: number
    ) {
        const p = this.item.prices.find((e: any) => e.price_type_id === price_type_id)

        if (p) {
            p[field] = value
        } else {
            this.item.prices.push({
                price_type_id: price_type_id,
                price: field === 'price' ? value : 0,
                old_price: field === 'old_price' ? value : 0,
            })
        }
    }

    setWhPrice(
        price_type_id: number,
        warehouse_id: number,
        field: 'price' | 'old_price',
        value: number
    ) {
        const p = this.item.prices_wh.find((e: any) => e.price_type_id === price_type_id && e.warehouse_id === warehouse_id)

        if (p) {
            p[field] = value
        } else {
            this.item.prices_wh.push({
                price_type_id: price_type_id,
                warehouse_id: warehouse_id,
                price: field === 'price' ? value : 0,
                old_price: field === 'old_price' ? value : 0,
            })
        }
    }

    setLinkValue(product_id: Number, key: string, value: any) {
        console.log(product_id, key, value)
        runInAction(() => {
            let index = this.item.product_relations.findIndex((rec: any) => rec.product_id === product_id)
            this.item.product_relations[index][key] = value
        })
    }

    changeRelationLists(id: any, values: any) {
        let index = this.item.product_relations.findIndex((rec: any) => rec.id === id)
        console.log(this.item.product_relations[index])
        this.item.product_relations[index].lists = values.map((id: any) => ({
            category_id: id
        }))
    }

    deleteRelation(product_id: number) {
        this.item.product_relations = this.item.product_relations.filter((el: any) => el.product_id !== product_id)

    }

    getModifiersGroups(force = false) {
        if (!force && (this.modifiersGroupsLoaded || this.modifiersGroupsLoading)) return

        this.modifiersGroupsLoading = true

        openApi('get', `/modifiers_groups`)
            .then(result => {
                this.modifiers_groups = Array.isArray(result.data) ? [...result.data].reverse() : []
                this.modifiersGroupsLoaded = true
            })
            .catch(error => {
                console.log(error.response)
            })
            .finally(() => {
                this.modifiersGroupsLoading = false
            })
    }

}

export const __product = new ProductController()